module.exports = __webpack_public_path__ + "static/media/dhn-newlogo.b055de06.jpg";